import { type GasPayload } from '@atlaskit/analytics-gas-types';

import type { ConnectorSource } from '../../../constants/schemas/3p-config';
import type { NonPrivacySafeAttributes } from '../../events/types';

type ThirdPartyLinkClickedAttributes = {
	commonAttributes: Record<string, any>;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
	linkProduct?: string;
	isSmartLink?: boolean;
	connectorType?: ConnectorSource;
	position?: number;
	rightOrLeftClick: 'left' | 'right';
};

export const onThirdPartyLinkClicked = ({
	commonAttributes,
	nonPrivacySafeAttributes,
	...rest
}: ThirdPartyLinkClickedAttributes): GasPayload => ({
	eventType: 'ui',
	action: 'clicked',
	actionSubject: 'thirdPartyLink',
	attributes: {
		experienceName: 'quick-find',
		...commonAttributes,
		...rest,
	},
	nonPrivacySafeAttributes,
});
